import React from 'react';
import { Stack, Box, LinearProgress } from '@mui/material';
import Lottie from 'react-lottie';
import { styles } from './styles';
import { FelixGPTIcon } from '../../AIStudio/SharedComponents/Graphics/FelixSVG';
import felixSearching from '../../AIStudio/SharedComponents/Graphics/felix-searching.json';

export default function FelixAnimation({
  query,
  progressVisible,
  transitioningStep,
  currentStep,
  progress
}: {
  query?: string;
  progressVisible: boolean;
  transitioningStep: boolean;
  currentStep: string;
  progress: number;
}) {
  const loadingAnimation = {
    loop: true,
    autoplay: true,
    animationData: felixSearching,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Box sx={{ position: 'relative', height: '45px', width: '45px' }}>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          sx={{
            ...styles.fadedFull,
            opacity: progressVisible ? 0 : 1
          }}
        >
          <FelixGPTIcon />
        </Stack>
        <Box
          sx={{
            ...styles.fadedFull,
            opacity: progressVisible ? 1 : 0
          }}
        >
          <Lottie options={loadingAnimation} style={styles.animationLottie} />
        </Box>
      </Box>
      <Box sx={styles.felixDescription}>
        <Stack
          sx={{
            ...styles.fadedFull,
            opacity: progressVisible ? 1 : 0,
            width: '30%',
            minWidth: '300px'
          }}
        >
          <em
            style={{
              opacity: transitioningStep ? 0 : 1,
              transition: 'opacity 0.3s ease-in-out',
              color: '#6E6E6E'
            }}
          >
            {currentStep || 'Searching...'}
          </em>
          <Box sx={styles.progressWrapper}>
            <LinearProgress variant="determinate" value={progress} sx={styles.progressBar} />
          </Box>
        </Stack>
        <Stack
          sx={{
            ...styles.fadedFull,
            opacity: progressVisible ? 0 : 1
          }}
          justifyContent="center"
          direction="column"
        >
          <em>
            {query
              ? 'Click on Search to expand the current filters and search'
              : 'Enter a query to start'}
          </em>
        </Stack>
      </Box>
    </Stack>
  );
}
